import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../Core/RichText';

import {
  Banner,
  ImageWrapper,
  Img,
  StyledLogo,
  Content,
  Heading,
  StyledCtas,
  Body,
} from './styles';

const options = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => {
      return <Body>{children}</Body>;
    },
  },
};

const preheadOptions = {
  renderNode: {
    [BLOCKS.EMBEDDED_ENTRY]: node => {
      const { data } = node;
      if (data.target.__typename === 'ContentfulDamAsset') {
        return (
          <StyledLogo src={data.target} altText={data.target.altText || ''} />
        );
      }
      return null;
    },
  },
};

const BannerBlock = ({ data = null, className = '' }) => {
  if (!data) return false;

  const {
    id,
    component,
    imageDam,
    bodyCopy,
    preHeading,
    heading,
    ctas,
    backgroundColor,
  } = data;

  return (
    <Banner
      key={id}
      $backgroundColor={backgroundColor}
      className={`${component} ${className}`}
    >
      {imageDam && (
        <ImageWrapper>
          <Img src={imageDam} alt={imageDam.altText || ''} />
        </ImageWrapper>
      )}
      {bodyCopy && (
        <Content>
          {preHeading && (
            <RichText document={preHeading} options={preheadOptions} />
          )}
          {heading && (
            <Heading>
              <RichText document={heading} />
            </Heading>
          )}
          {bodyCopy && <RichText document={bodyCopy} options={options} />}
          {ctas && <StyledCtas ctas={ctas} />}
        </Content>
      )}
    </Banner>
  );
};

BannerBlock.propTypes = {
  data: PropTypes.shape(),
  className: PropTypes.string,
};

export default BannerBlock;
